import { Component, inject, Input, OnInit } from '@angular/core';
import { HeaderConfigurationComponent } from '../../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { IonButton, IonContent } from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import {
  Pool,
  PoolAdditionalData,
} from '../../../../../../../../apis/pool.api';
import { IProduct } from '../../../../../IProduct';
import { LabelConfigurationComponent } from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { getMasterFirmwareVersionFromPool } from '../../../../../../ECoSystemsHelper';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import {
  P00039EclairageNameEnum,
  P00039EclairageTypeEnumFn,
} from '../../../../P00039/Enum/P00039EclairageTypeEnum';
import { P0003605DureeQuotidienneInjection } from '../../../Enum/P0003605DureeQuotidienneInjection';

@Component({
  selector: 'app-p0003605-injection-chlore-mise-en-oeuvre-hivernage',
  templateUrl:
    './p0003605-injection-chlore-mise-en-oeuvre-hivernage.component.html',
  styleUrls: [
    './p0003605-injection-chlore-mise-en-oeuvre-hivernage.component.scss',
  ],
  standalone: true,
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    TranslatePipe,
    LabelConfigurationComponent,
  ],
})
export class P0003605InjectionChloreMiseEnOeuvreHivernageComponent
  implements OnInit
{
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  @Input() pool: Pool | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly getMasterFirmwareVersionFromPool =
    getMasterFirmwareVersionFromPool;
  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P00039EclairageNameEnum = P00039EclairageNameEnum;
  protected readonly P00039EclairageTypeEnumFn = P00039EclairageTypeEnumFn;
  protected readonly P0003605DureeQuotidienneInjection =
    P0003605DureeQuotidienneInjection;
}
